import React from "react";

export const Error404 = () => {
  const bg =
    "https://images.unsplash.com/photo-1529336953121-a0ce2b6a6c8f?auto=format&fit=crop&w=2400&q=80";

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(255,255,255,.88) 0%, rgba(255,255,255,.96) 40%, rgba(255,255,255,1) 100%)",
        }}
      />

      <div
        style={{
          width: "min(880px, 100%)",
          position: "relative",
          borderRadius: 24,
          overflow: "hidden",
          background: "#1397e4ff",
          boxShadow: "0 30px 80px rgba(0,0,0,.15)",
        }}
      >
        <div
          style={{
            padding: "22px 28px",
            borderBottom: "1px solid #eee",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 800,
              letterSpacing: -0.3,
              color: "#ffffffff",
            }}
          >
            Fixer Aviation
          </div>
          <div
            style={{
              fontSize: 12,
              color: "white",
            }}
          >
            Error Page
          </div>
        </div>

        <div
          style={{
            padding: "46px 36px",
            display: "flex",
            flexWrap: "wrap",
            gap: 40,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ maxWidth: 480 }}>
            <div
              style={{
                fontSize: 92,
                fontWeight: 900,
                letterSpacing: -3,
                color: "white",
                lineHeight: 1,
              }}
            >
              404
            </div>

            <div
              style={{
                marginTop: 14,
                fontSize: 22,
                fontWeight: 700,
                color: "white",
              }}
            >
              Page not found
            </div>

            <div
              style={{
                marginTop: 10,
                fontSize: 15,
                lineHeight: 1.6,
                color: "white",
              }}
            >
              The page you are looking for might have been removed, moved, or is
              temporarily unavailable. You can return to the homepage or go back
              to the previous page.
            </div>

            <div
              style={{
                display: "flex",
                gap: 12,
                marginTop: 26,
                flexWrap: "wrap",
              }}
            >
              <a
                href="/"
                style={{
                  padding: "13px 18px",
                  borderRadius: 14,
                  textDecoration: "none",
                  background: "white",
                  color: "purple",
                  fontWeight: 700,
                  fontSize: 14,
                  boxShadow: "0 14px 30px rgba(0,0,0,.18)",
                }}
              >
                Go to homepage
              </a>

              <button
                onClick={() => window.history.back()}
                style={{
                  padding: "13px 18px",
                  borderRadius: 14,
                  border: "1px solid #ddd",
                  background: "#fff",
                  color: "purple",
                  fontWeight: 700,
                  fontSize: 14,
                  cursor: "pointer",
                }}
              >
                Go back
              </button>
            </div>
          </div>

          <div
            style={{
              width: 260,
              borderRadius: 20,
              border: "1px solid #eee",
              background: "#fafafa",
              padding: 22,
            }}
          >
            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "#222",
              }}
            >
              What you can do
            </div>

            <ul
              style={{
                marginTop: 12,
                paddingLeft: 18,
                fontSize: 13,
                lineHeight: 1.6,
                color: "#555",
              }}
            >
              <li>Check the URL</li>
              <li>Continue from the main menu</li>
              <li>Return to the homepage</li>
              <li>This page may require additional permissions</li>
            </ul>
          </div>
        </div>

        <div
          style={{
            padding: "16px 28px",
            borderTop: "1px solid #eee",
            display: "flex",
            justifyContent: "space-between",
            fontSize: 12,
            color: "white",
          }}
        >
          <div>© {new Date().getFullYear()} Fixer Aviation</div>
          <div>404 Not Found</div>
        </div>
      </div>
    </div>
  );
};
